import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  styleLable?: object;
  labelStyles?: string;
}
export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  styleLable?: object;
  labelStyles?: string;
  disablePlaceholderAnimation?: boolean;
  inputSize?: "sm" | "md" | "lg";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      styleLable: styleLabel,
      type,
      placeholder,
      labelStyles,
      onAnimationStart,
      disablePlaceholderAnimation = false,
      inputSize,
      ...props
    },
    ref
  ) => {
    const innerRef = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => innerRef.current!);

    const [initialLoad, setInitialLoad] = React.useState(true);

    React.useEffect(() => {
      setTimeout(() => setInitialLoad(false), 500);
    }, []);

    return (
      <div className="relative">
        <input
          type={type}
          className={cn(
            "rounded-[10px] flex peer input h-14 w-full",
            "focus:outline-none transition-all duration-300",
            "border border-neutral-200 p-4 pr-3 text-xl ring-offset-white",
            "file:border-0 file:bg-transparent file:text-xl file:font-medium file:text-neutral-950",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950",
            "border-2 border-[#00000033] focus:border-blue-medium",
            "focus-visible:ring-transparent focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            "dark:border-neutral-800 dark:ring-offset-neutral-950",
            "dark:file:text-neutral-50 dark:focus-visible:ring-neutral-300",
            !disablePlaceholderAnimation && "placeholder:opacity-0 focus:placeholder:opacity-0",
            className
          )}
          placeholder={placeholder}
          onAnimationStart={(e) => {
            if (initialLoad && e.animationName === "onAutofill") {
              innerRef.current?.focus();
              innerRef.current?.blur();
              setInitialLoad(false);
            }

            if (onAnimationStart) {
              onAnimationStart(e);
            }
          }}
          ref={innerRef}
          {...props}
        />
        {!disablePlaceholderAnimation && (
          <label
            style={styleLabel}
            className={cn(
              "absolute left-3.5 top-1/2 transform -translate-y-1/2 px-1 bg-white",
              "text-[#00000080] font-medium text-xl transition-all duration-100 pointer-events-none",
              "peer-focus:top-0 peer-focus:text-sm peer-focus:z-10",
              "peer-focus:text-blue-medium",
              "peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-sm peer-[:not(:placeholder-shown)]:z-10",
              inputSize === "sm" && "text-[12px]",
              labelStyles
            )}
          >
            {placeholder}
          </label>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
